var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.message)?_c('div',{staticClass:"bg-grey-100 rounded-sm px-16 py-12 mt-20 mb-10 flex"},[_vm._m(0),_c('p',[_vm._v(" "+_vm._s(_vm.message)+" ")])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mr-12 mt-6"},[_c('span',{staticClass:"fa fa-exclamation text-grey-100 bg-blue-500 rounded-full w-20 h-20 flex items-center justify-center text-xxs",attrs:{"aria-hidden":"true"}})])
}]

export { render, staticRenderFns }